module.exports = __webpack_public_path__ + "static/media/29DUNON1.f0859264.jpg";